<template>
    <submit-query-modal
            :show.sync="visible"
            :is-bulk="true"
            :options-prop="queryOptions"
            :client-action-id="clientActionIds"
            @submit-bulk-query="submitQueries($event)"
    >
        <font-awesome-icon
                class="mr-2"
                :icon="['fa', 'question-circle']">
        </font-awesome-icon>
        These queries will all go to the same team manager of the selected action
    </submit-query-modal>
</template>

<script>
import SubmitQueryModal from '@/components/Action/Modal/SubmitQueryModal';
import Action from '@/services/Action/Action';
import ErrorMixin from '@/components/Notifications/ErrorMixin';
import AssignSelect from '@/components/Form/AssignSelect';
import FileDropMixin from '@/components/Form/FileDropMixin';

export default {
  name: 'Submit-Bulk-Queries-Modal',
  components: {
    SubmitQueryModal,
    AssignSelect,
  },
  props: {
    clientActionIds: {
      required: true,
    },
    show: {
      required: true,
    },
  },
  mixins: [ErrorMixin, FileDropMixin],
  data() {
    return {
      modalId: 'submitBulkQueriesModal',
      loading: false,
      options: [],
      visible: true,
      form: {
        recipient: null,
      },
    };
  },
  computed: {
    hasOptions() {
      return this.options.length > 0 || this.form.recipient;
    },
    queryOptions() {
      return {
        ...this.dropOptions,
        url: this.url
      }
    }
  },
  watch: {
    visible(newVisible) {
      if (!newVisible) {
        this.$emit('update:show');
      }
    },
  },
  created() {
    this.visible = this.show;
  },
  mounted() {
    this.setOptions();
  },
  methods: {
    async submitQueries({ query, teamId, userId }) {
      if (this.clientActionIds.length === 0) {
        this.notifyError('No actions selected');
        this.visible = false;
        return;
      }

      try {
        await Action.bulkQuery(this.clientActionIds, query, teamId, userId);


        const title = 'Queries processed';
        const text = 'Queries are currently being submitted.';
        const type = 'success';

        this.$notify({
          duration: 7000,
          title,
          text,
          type,
        });

        this.$store.dispatch('refreshActions');
        this.visible = false;
      } catch (e) {
        this.showErrorMessage(e);
      } finally {
        this.loading = false;
      }
    },
    async setOptions() {
      this.loading = true;
      try {
        const { data } = await Action.getTeamManagers(this.clientActionIds[0]);

        const { managers } = data.data;

        const options = [];

        if (managers) {
          let team = '';
          if (managers.length === 1) {
            const onlyManager = managers[0];
            onlyManager.teamId = onlyManager.team.teamId;
            this.form.recipient = onlyManager;
            return;
          }

          const items = [];
          managers.forEach((manager) => {
            team = manager.team.team;

            items.push({
              label: `${manager.firstName} ${manager.lastName}`,
              userId: manager.userId,
              user: manager.userId,
              teamId: manager.team.teamId,
            });
          });

          const teamOpt = {
            team: `${team} managers`,
            items,
          };

          options.push(teamOpt);
        }

        this.options = options;
      } catch (e) {
      } finally {
        this.loading = false;
      }
    },

  },
};
</script>
